import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'vtr-material-checkbox',
	templateUrl: './material-checkbox.component.html',
})
export class MaterialCheckboxComponent {
	@Input() componentId: string;
	@Input() ariaLabel: string;
	@Input() label: string;
	@Input() checked = false;
	@Input() indeterminate = false;
	@Input() disabled = false;
	@Input() value: any;
	@Input() hasChild = false; // for ng-content
	@Output() toggle: EventEmitter<boolean> = new EventEmitter();

	constructor() {}

	onChange(event) {
		const value = event.target?.checked || event.checked;
		this.checked = value;
		this.toggle.emit(value);
	}

	onEnterKeydown() {
		this.checked = !this.checked;
		this.toggle.emit(this.checked);
	}
}
